export default "__VITE_ASSET__bf9eb46d__"